export const iconFontAwesomeHumanitarianShieldHeart = (
	<i className="fa-solid fa-shield-heart"></i>
);
